<template>
	<main class="mypage edit">
		<UserMenu v-if="displayStore.isDesktop" />
		<article class="userInfo">
			<section class="user_form">
				<h6>휴대폰 번호 인증</h6>

				<div class="c_fieldArea">
					<FieldPhoneValidate
						v-model:phoneNum="member_cell"
						v-model:isPhoneValid="member_cell_valid"
						required
						:phoneNum_error="errors.member_cell"
						:isPhoneValid_error="errors.member_cell_valid"
						phone-type="Check"
						type="join"
						@update:is-phone-code="(value) => changePhoneCode(value)"
						@update:phone-num="(value) => chagePhoneNumber(value)"
						@update:is-phone-valid="(value) => changeCellValid(value)"
						@update:set-field-error="(value) => onChangePhoneError(value)"
					/>

					<button
						class="c_button radius-x-small primary-fill save"
						:disabled="!member_cell || !member_cell_valid"
						@click="onClickSavePhoneNumber"
					>
						완료
					</button>
				</div>
			</section>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { useRouter } from 'vue-router';
import { useForm } from 'vee-validate';
// validation
import * as yup from 'yup';

import { useModifyMemberPhoneApi } from '@/api/mypage';
// component
import FieldPhoneValidate from '@/components/form/FieldPhoneValidate.vue';
import UserMenu from '@/components/mypage/UserMenu.vue';
// constant
import { phoneRegex } from '@/constants/regex';
import {
	ERROR_REQUIRED_FIELD,
	MESSAGE_PHONE_VERIFICATION_COMPLETED,
	MESSAGE_VERIFY_PHONE_NUMBER,
} from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';

// -----variable-----
const displayStore = useDisplayStore();
const router = useRouter();

// -----validation-----
const { meta, errors, defineField, setFieldError, validate } = useForm({
	validationSchema: yup.object({
		member_cell: yup
			.string()
			.required(ERROR_REQUIRED_FIELD)
			.min(13, '')
			.matches(phoneRegex, MESSAGE_VERIFY_PHONE_NUMBER),
		member_cell_code: yup.string(),
		member_cell_valid: yup.boolean().isTrue(MESSAGE_PHONE_VERIFICATION_COMPLETED),
	}),
	initialValues: {
		member_cell: '',
		member_cell_valid: false,
		member_cell_code: '',
	},
});
const [member_cell] = defineField('member_cell');
const [member_cell_valid] = defineField('member_cell_valid');
const [member_cell_code] = defineField('member_cell_code');

// -----api-----
const { mutateAsync: modifyMemberPhone, isPending: isModifyMemberPending } = useModifyMemberPhoneApi();

// -----function-----
const onClickSavePhoneNumber = async () => {
	const { valid } = await validate();
	if (!valid) {
		return;
	}
	if (isModifyMemberPending.value || !meta.value.valid) {
		return;
	}
	await modifyMemberPhone({
		phonenum: member_cell.value,
		identification_no: member_cell_code.value,
	});
	router.push('/my/edit');
};
const changeCellValid = (v: boolean) => {
	member_cell_valid.value = v;
};

const chagePhoneNumber = (v: string) => {
	member_cell.value = v;
};
const changePhoneCode = (v: string) => {
	member_cell_code.value = v;
};
const onChangePhoneError = (value: string) => {
	setFieldError('member_cell', value);
};
</script>

<style lang="scss" scoped>
.edit {
	margin-bottom: 7.2rem;
	.userInfo {
		max-width: 40rem;
		margin: 0 auto;
		width: 100%;
		.user_form {
			display: flex;
			flex-direction: column;
			gap: var(--space-xxx-large);

			.c_fieldArea .receive {
				font-weight: var(--font-w-regular);
				font-size: var(--font-s-mid);
				line-height: 1.9rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
			.form_phone {
				display: flex;
				flex-direction: column;
				gap: 1rem;
				.timer {
					color: red;
				}
			}
			.save {
				height: 4.8rem;
			}
			.button_wrap {
				text-align: center;
				.secession {
					font-weight: var(--font-w-regular);
					font-size: var(--font-s-mid);
					color: var(--color-base-light);
					line-height: 1.9rem;
					width: fit-content;
					border-bottom: 1px solid var(--color-base-light);
					border-radius: 0;
					padding: 0;
					height: none;
				}
			}
		}
	}
}
</style>
